// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.data.OpenEdgeConfigurationResponse */
/* istanbul ignore next */
@GandalfModel
export class OpenEdgeConfigurationResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Boolean })
	geniusSimulate!: boolean | null;

	@GandalfProperty({ designType: String })
	payFieldsApiKey!: string | null;

	@GandalfProperty({ designType: String })
	payFieldsEnvironment!: string | null;

	@GandalfProperty({ designType: String })
	simulatorEndpoint!: string | null;

}
